import { render, staticRenderFns } from "./QDormantStatuses.vue?vue&type=template&id=20f2427e&scoped=true&"
import script from "./QDormantStatuses.vue?vue&type=script&lang=js&"
export * from "./QDormantStatuses.vue?vue&type=script&lang=js&"
import style0 from "./QDormantStatuses.vue?vue&type=style&index=0&id=20f2427e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2427e",
  null
  
)

export default component.exports